<template>
  <div class="addcard">
    <div class="flex" style="flex-direction: column;flex:0">
      <div class="nav">
        <span class="line"></span>
        <div
          class
          :class="{ bordercss: active }"
          @click.prevent="active = true"
        >
          在线建档
        </div>
        <div :class="{ bordercss: !active }" @click.prevent="active = false">
          绑定就诊卡
        </div>
      </div>
      <!-- 在线建档内容开始 -->
      <div v-show="active">
        <form>
          <div class="cardcont">
            <p>
              <span>姓名：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="userInfo.name"
                  :readonly="readonly"
                />
              </span>
            </p>
            <p @click="checkPicker">
              <span>性别：</span>
              <span>
                <input
                  type="text"
                  placeholder="男"
                  v-model="infosex"
                  disabled="disabled"
                />
                <!-- <span>{{userInfo.sex}}</span> -->
                <span></span>
              </span>
            </p>
            <p>
              <span>身份证号：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="userInfo.credentialNumber"
                  :readonly="readonly"
                />
              </span>
            </p>
            <p>
              <span>手机号：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入手机号"
                  v-model="userInfo.phoneNumber"
                  :readonly="readonly"
                  @blur.prevent="phoneBlur()"
                />
              </span>
            </p>
            <p>
              <span>所在地区：</span>
              <span>
                <input
                  type="text"
                  placeholder="请选择地区"
                  v-model="addr"
                  :readonly="readonly"
                  @click="checkAddress"
                />
                <my-address
                  ref="uiaddr"
                  :show.sync="showAddress"
                  @check="getValue"
                />
              </span>
            </p>
            <p>
              <span>详细地址：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入详细地址"
                  v-model="addrDetail"
                />
              </span>
            </p>
          </div>
        </form>

        <div class="prompt">
          <p>温馨提示：</p>
          <p>
            1.无医院就诊卡的用户请通过“在线建档”完成电子建档，即可进行预约挂号等功能操作。就诊当日凭身份证或户口本到诊室就诊。
          </p>
          <p>
            2.已有医院就诊卡的用户请通过“绑定就诊卡”完成绑卡，即可进行预约挂号等功能操作。
          </p>
          <p>
            3.填写就诊人的信息必须与有效证件（身份证、户口本等）上的信息一致，如填写有误，将影响APP内预约挂号等功能的正常使用。
          </p>
        </div>
      </div>
      <!-- 在线建档内容结束 -->

      <div v-show="!active">
        <form>
          <div class="cardcont">
            <p>
              <span>姓名：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="cardInfo.name"
                />
              </span>
            </p>
            <p>
              <span>身份证号：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="cardInfo.credentialNumber"
                />
              </span>
            </p>
            <p>
              <span>就诊卡号：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入就诊卡号"
                  v-model="cardInfo.cardNumber"
                />
              </span>
            </p>
            <p>
              <span>手机号：</span>
              <span>
                <input
                  type="text"
                  placeholder="请输入办理就诊卡预留手机号"
                  v-model="cardInfo.phoneNumber"
                  @blur.prevent="phoneBlur()"
                />
              </span>
            </p>
          </div>
        </form>

        <div class="prompt">
          <p>温馨提示：</p>
          <p>
            1.医院实行实名制就诊，请使用在医院办理就诊卡提供的信息，需核对姓名、身份证号信息、手机号信息
            一致方可绑定。
          </p>
          <p>
            2.绑卡出现信息不一致无法绑定时，需前往人工办卡地点更正信息后再做绑卡操作。
          </p>
          <p>
            3.无医院就诊卡用户可通过“在线建档”完成电子建档，即可进行预约挂号等功能操作。
          </p>
          <p>4.一个微信号可以绑定5张就诊卡</p>
        </div>
      </div>
    </div>
    <div class="addbnt1" @click="Btntian" v-show="!active">
      <span>检索就诊卡</span>
    </div>
    <div class="addbnt" @click="goHome">
      <span>确定添加</span>
    </div>
    <!-- 底部弹窗 -->
    <van-popup v-model="shows" position="bottom" :style="{ height: '50%' }">
      <div class="padinglr">
        <div class="popText">检索到就诊卡</div>
        <div style="overflow: scroll;  height: 40vh;">
          <div
            class="content"
            v-for="(item, index) in resultData"
            :key="index"
            :class="cerIndex == index ? 'active' : ''"
            @click="cretentBtn(item, index)"
          >
            <div class="name">{{ item.PatName }}</div>
            <div class="dispaly">
              <div style="margin-right: 20px;">
                {{ item.CardNo }}
              </div>
              <div>手机号 {{ item.PhoneNumber }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 遮罩弹窗 -->
    <div class="popChoose" v-show="isshow">
      <div class="popcon">
        <div>
          <span @click="cancel">取消</span>
        </div>
        <p class="bd" @click="woman">女</p>
        <p class="bt" @click="man">男</p>
      </div>
    </div>
    <!-- 结束 -->
  </div>
</template>
<script>
import {
  GetUserInfoByOpenID,
  AddOrUpdateUser,
  BinDingCard,
  GetItem,
  GetUserCardNo
} from "@/services/getData.js";
import weui from "weui.js";
import MyAddress from "@/components/address";
export default {
  name: "add-card",
  components: {
    MyAddress
  },
  data() {
    return {
      isshow: false,
      shows: false,
      readonly: false,
      active: true,
      infosex: "男",
      userInfo: {
        name: "",
        sex: "",
        credentialNumber: "",
        phoneNumber: "",
        guid: ""
      },
      cardInfo: {
        name: "",
        credentialNumber: "",
        phoneNumber: "",
        cardNumber: ""
      },
      pagefrom: this.$route.query.pagefrom,
      $dialog: [],
      addr: "请选择",
      addrDetail: "",
      addrJson: "",
      showAddress: false,
      cardList: [],
      resultData: {},
      idCardParmas: "",
      phoneCardParmas: "",
      cerIndex: null
    };
  },
  created: function() {
    //active 切换事件
    if (!this.$route.query.active) {
      this.active = this.$route.query.active;
    } else {
      this.active = true;
    }
    this.cardList = this.$route.query.PatInfos;
    this.getUserInfoByOpenID();
  },
  destroyed: function() {
    if (Object.prototype.toString.call(this.$dialog) !== "[object Function]") {
      this.$dialog.hide();
    }
  },
  methods: {
    cretentBtn(item, index) {
      this.cerIndex = index;
      this.shows = false;
      // 回显
      this.cardInfo.name = item.PatName;
      this.cardInfo.phoneNumber = item.PhoneNumber;
      this.cardInfo.credentialNumber = item.IDNumber;
      this.cardInfo.cardNumber = item.CardNo;
    },
    getCardID() {
      GetUserCardNo({
        PhoneNumber: this.cardInfo.phoneNumber,
        IDNumber: this.cardInfo.credentialNumber
      }).then(res => {
        if(res.data == [] || res.data.length == 0) {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "未检索到就诊卡"
          });
        } else {
         this.resultData = res.data;
         this.shows = true
        }
      });
    },
    Btntian() {
      if (this.cardInfo.credentialNumber.length == 0) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请填写身份证"
        });
        return;
      }
      if (this.cardInfo.phoneNumber.length == 0) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请填写手机号"
        });
        return;
      }
      this.getCardID();
    },
    checkAddress() {
      this.showAddress = true;
      this.$refs.uiaddr.choseAdd(this.addrJson);
    },
    getValue(par) {
      this.showAddress = false;
      console.log("选择得值", par);
      this.addrJson = par;
      this.addr = par.name[0] + par.name[1] + par.name[2];
    },
    checkPicker: function() {
      var _that = this;
      weui.picker(
        [
          {
            label: "男",
            value: 1
          },
          {
            label: "女",
            value: 0
          }
        ],
        {
          onChange: function(result) {
            // console.log(result);
          },
          onConfirm: function(result) {
            _that.infosex = result["0"]["label"];
            _that.userInfo.sex = result["0"]["label"];
          }
        }
      );
    },
    phoneBlur() {
      window.scroll(0, 0);
    },
    phoneChange() {
      window.scroll(0, 0);
    },

    goHome() {
      if (this.active) {
        this.addOrUpdateUser();
      } else {
        this.binDingCard();
      }
    },
    getUserInfoByOpenID() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetUserInfoByOpenID().then(response => {
        loading.hide();
        if (response.data) {
          var data = response.data;
          this.userInfo.name = data.Name;
          this.infosex = data.Sex;
          this.userInfo.sex = data.Sex;
          this.userInfo.phoneNumber = data.PhoneNumber;
          this.userInfo.credentialNumber = data.CredentialNumber;
          this.readonly = true;

          var patLists = JSON.parse(this.cardList);
          for (var i = 0; i < patLists.length; i++) {
            if (patLists[i].PatID == data.PatNo) {
              if (
                patLists[i].RegionStr != undefined &&
                patLists[i].RegionStr != ""
              ) {
                var addstr = JSON.parse(patLists[i].RegionStr);
                this.addr =
                  addstr.ProvinceName + addstr.CityName + addstr.CountyName;
                this.addrDetail = addstr.DetailAddress;
                this.addrJson = {
                  name: [
                    addstr.ProvinceName,
                    addstr.CityName,
                    addstr.CountyName
                  ],
                  code: [addstr.ProvinceCode, addstr.CityCode, addstr.CountyID]
                };
              }
              break;
            }
          }
        }
      });
    },
    addOrUpdateUser() {
      if (GetItem("userid")) {
        //已经包含
        this.$dialog = weui.dialog({
          title: "提示",
          content: "已经有档案了"
        });
      } else {
        //未包含
        if (this.userInfo.name.length == 0) {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "请填写姓名"
          });
          return;
        }
        if (this.userInfo.phoneNumber.length == 0) {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "请填写手机号"
          });
          return;
        }
        if (this.userInfo.credentialNumber.length == 0) {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "请填写身份证"
          });
          return;
        }
        if (this.addrJson == null || this.addrJson == "") {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "请选择现住地址"
          });
          return;
        }
        if (this.addrDetail.length == 0) {
          this.$dialog = weui.dialog({
            title: "提示",
            content: "请选择详细地址"
          });
          return;
        }
        var loading = weui.loading("loading", {
          className: "custom-classname",
          content: "加载中"
        });
        var isQRCode = this.$route.query.qrCode == true ? true : false;
        var regionStr = {
          ProvinceCode: this.addrJson.code[0],
          ProvinceName: this.addrJson.name[0],
          CityCode: this.addrJson.code[1],
          CityName: this.addrJson.name[1],
          CountyID: this.addrJson.code[2],
          CountyName: this.addrJson.name[2],
          DetailAddress: this.addrDetail
        };
        AddOrUpdateUser(
          this.userInfo.name,
          this.infosex,
          this.userInfo.phoneNumber,
          this.userInfo.credentialNumber,
          isQRCode,
          JSON.stringify(regionStr)
        ).then(response => {
          loading.hide();
          if (response.data.Result) {
            //跳转到主页
            this.$router.push({ path: "/", params: { userId: 123 } });
          } else {
            this.$dialog = weui.dialog({
              title: "提示",
              content: response.data.Content
            });
          }
        });
      }
    },
    choosesex() {
      this.isshow = true;
    },
    cancel() {
      this.isshow = false;
    },
    woman() {
      this.userInfo.sex = "女";
      this.isshow = false;
    },
    man() {
      this.userInfo.sex = "男";
      this.isshow = false;
    },
    binDingCard() {
      if (this.cardInfo.name.length == 0) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请填写姓名"
        });
        return;
      }
      if (this.cardInfo.phoneNumber.length == 0) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请填写手机号"
        });
        return;
      }
      if (this.cardInfo.credentialNumber.length == 0) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请填写身份证"
        });
        return;
      }
      if (this.cardInfo.cardNumber.length == 0) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "请填写卡号"
        });
        return;
      }
      if (!/^1[34578]\d{9}$/.test(this.cardInfo.phoneNumber)) {
        this.$dialog = weui.dialog({
          title: "提示",
          content: "手机号码不正确"
        });
        return;
      }
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      BinDingCard(
        this.cardInfo.name,
        this.cardInfo.credentialNumber,
        this.cardInfo.cardNumber,
        this.cardInfo.phoneNumber
      ).then(response => {
        loading.hide();
        if (response.data.Result) {
          //跳转到主页
          //this.$router.push({ path: "/", params: { userId: 123 } });
          this.$router.back(-1);
        } else {
          this.$dialog = weui.dialog({
            title: "提示",
            content: response.data.Content
          });
        }
      });
    }
  }
};
</script>

<style>
.name {
  font-weight: bold;
  color: #7f7f7f;
}
.content {
  margin-top: 10px;
  padding: 10px;
}
.active {
  border: 1px solid #1592e4;
}
.dispaly {
  color: #979797;
  display: flex;
  padding: 6px 12px 0 0;
}
.padinglr {
  padding: 10px;
}
.popText {
  color: 303030;
  font-weight: bold;
  font-size: 18px;
}
.addcard {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.nav {
  width: 100%;
  height: 0.8rem;
  margin-bottom: 0.2rem;
  position: relative;
  background-color: white;
}

.nav .line {
  position: absolute;
  display: inline-block;
  height: 0rem;
  height: 0.8rem;
  border: 0.01rem solid #dddddd;
  left: 50%;
}

.nav > div {
  float: left;
  width: 50%;
  height: 0.8rem;
  font-size: 0.24rem;
  color: #666666;
  text-align: center;
  line-height: 0.8rem;
  border-bottom: 0.04rem solid #dddddd;
  font-family: "MicrosoftYaHei";
}

.bordercss {
  border-bottom: 0.04rem solid #1592e4 !important;
  color: #1592e4 !important;
}

.addcard .flex {
  flex: 1;
  /* height: calc(100% - 0.8rem); */
}

.addcard .cardcont {
  background: white;
  font-size: 0.26rem;
}

.cardcont > p {
  border-bottom: 0.01rem solid #dddddd;
  height: 0.8rem;
  line-height: 0.8rem;
  /* margin: 0.2rem; */
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}

.cardcont p span:last-child {
  float: right;
  width: 60%;
  height: 0.72rem;
}

.cardcont p input {
  text-align: right;
  font-size: 0.26rem;
  width: 100%;
  height: 100%;
  float: right;
}

.addcard .prompt {
  margin-left: 0.2rem;
  font-size: 0.2rem;
  color: #999999;
  margin-top: 0.2rem;
}

.cardcont > input::-webkit-input-placeholder {
  text-align: right;
  color: #999999;
  font-size: 0.26rem;
}

input[type="text"][disabled] {
  background-color: white;
}

.addcard .addbnt {
  width: 94%;
  position: fixed;
  bottom: 0.1rem;
  background-color: #1592e4;
  height: 0.8rem;
  margin: 0.2rem;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  color: #fffefe;
  text-align: center;
  line-height: 0.8rem;
}
.addcard .addbnt1 {
  width: 93%;
  position: fixed;
  bottom: 1rem;
  border: 1px solid #1592e4;
  height: 0.8rem;
  margin: 0.2rem;
  font-family: "MicrosoftYaHei";
  font-size: 0.26rem;
  color: #1592e4;
  text-align: center;
  line-height: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/addcard/add-card.vue